<template>
  <a-button class="action_button" @click="click">
    <ThemeImage class="size-4" :icon="src" :alt="alt" />
    {{ text }}
  </a-button>
</template>

<script setup>
const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  click: {
    type: Function,
    required: false,
  },
});
</script>